import { createTheme } from '@mui/material/styles';

export const appTheme = createTheme({
    "palette": {
        "common": {
            "black":"#000",
            "white":"#fff"
        },
        "background": {
//            "paper": "#fff",
            "paper": "#F4F4F8",
//            "paper": "rgba(225, 243, 252, 1)",
//            "default": "#fafafa"
            "default": "#F4F4F8"
        },
        "primary": {
//          "light": "rgba(225, 243, 252, 1)",
            "light": "rgba(204, 235, 250, 1)",
            "main": "#09A4E8",
//            "main": "rgba(17, 182, 254, 1)",
            "dark": "rgba(1, 143, 207, 1)",
            "contrastText":"#fff"
        },
        "secondary": {
            "light":"rgba(250, 171, 100, 1)",
            "main":"rgba(255, 120, 1, 1)",
            "dark":"rgba(206, 98, 2, 1)",
            "contrastText":"#fff"
        },
        "buttonOrange": {
            "main":"rgba(238, 114, 3, 1)",
            "contrastText":"#fff"
        },
        "confirmOrange": {
            "main":"#d66602",
            "contrastText":"#fff"
        },
        "confirmBlue": {
            "main":"#003f5b",
            //"main":"#007eb6",
            "contrastText":"#fff"
        },
        "error": {
            "light":"rgba(230, 126, 126, 1)",
            "main":"rgba(247, 64, 51, 1)",
            "dark":"rgba(196, 44, 44, 1)",
            "contrastText":"#fff"
        },
        "text": {
            "main":"rgba(0, 0, 0, 0.87)",
            "primary":"rgba(0, 0, 0, 0.87)",
            "secondary":"rgba(0, 0, 0, 0.54)",
            "lighter":"rgba(0, 0, 0, 0.65)",
            "disabled":"rgba(0, 0, 0, 0.38)",
            "hint":"rgba(0, 0, 0, 0.38)",
            "textblue": "#007eb6",
            "light": "#fafafa"
        },
        "iconGreen": {
            "main": "rgba(21,169,98,1)"
        },
        "iconBlue": {
            "main": "#007eb6"
        },
        "iconDisabled": {
            "main": "rgba(0, 0, 0, 0.38)"
        },
        "capColorBackground": {
            "blue": "rgba(17, 182, 254, 1)",
            "orange": "rgba(255, 120, 1, 1)",
            "red": "rgba(247, 64, 51, 1)",
            "green": "rgba(21,169,98,1)",
            "yellow": "#ffee00",
            "pink": "#ffc0cb",
            "brown": "#683f00",
            "black": "#000",
            "white": "#fafafa",
            "blauw": "rgba(17, 182, 254, 1)",
            "oranje": "rgba(255, 120, 1, 1)",
            "rood": "rgba(247, 64, 51, 1)",
            "groen": "rgba(21,169,98,1)",
            "geel": "#ffee00",
            "roze": "#ffc0cb",
            "bruin": "#683f00",
            "zwart": "#000",
            "wit": "#fafafa"

        },
        "capColorText": {
            "blue": "#fff",
            "orange": "#000",
            "red": "#fff",
            "green": "#fff",
            "yellow": "rgba(0, 0, 0, 0.87)",
            "pink": "rgba(0, 0, 0, 0.87)",
            "brown": "#fff",
            "black": "#fff",
            "white": "rgba(0, 0, 0, 0.87)",
            "blauw": "#fff",
            "oranje": "#000",
            "rood": "#fff",
            "groen": "#fff",
            "geel": "rgba(0, 0, 0, 0.87)",
            "roze": "rgba(0, 0, 0, 0.87)",
            "bruin": "#fff",
            "zwart": "#fff",
            "wit": "rgba(0, 0, 0, 0.87)"

        }
    }
});
export default appTheme;